import Slider from "react-slick";
import { ArticlesFilteredsTypes } from "../../models/news-articles/articles-filtered-model";
import DepartmentsSliderCard393 from "./article/departments-slider-card393";
import DepartmentsSliderCard397 from "./article/departments-slider-card397";
import DepartmentsSliderCard400 from "./article/departments-slider-card400";
import DepartmentsSliderCard404 from "./article/departments-slider-card404";

var settings = {
  dots: true,
  infinite: true,
  speed: 2000,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
};

export type DepartmentsType = {
  ArticlesFiltereds393Data?: ArticlesFilteredsTypes[];
  ArticlesFilteredsData397?: ArticlesFilteredsTypes[];
  ArticlesFilteredsData398?: ArticlesFilteredsTypes[];
  ArticlesFilteredsData400?: ArticlesFilteredsTypes[];
  ArticlesFilteredsData404?: ArticlesFilteredsTypes[];
};

type NewsAndArticleSliderTypes = {
  cardMainTitle: string;
  cardMainHeading: string;
  cardSlidersec: string;
  cardSecTitle: string;
  cardSecSubTitle: string;
  cardSecContent: string;
  cardSecInfo: string;
  departments: DepartmentsType;
};
const DepartmentsSlider = (props: NewsAndArticleSliderTypes) => {
  return (
    <div className={props.cardMainTitle} id="features">
      <div className="row ">
        <div className="col-sm-12">
          <h2>{props.cardMainHeading}</h2>
        </div>
        <div className="col-sm-12">
            <div className={`${props.cardSlidersec} `}>
              <Slider {...settings}>
              <DepartmentsSliderCard397
                  article={props.departments.ArticlesFilteredsData397 || []}
                  cardSecTitle={props.cardSecTitle}
                  cardSecSubTitle={props.cardSecSubTitle}
                  cardSecContent={props.cardSecContent}
                  cardSecInfo={props.cardSecInfo}
                />
                <DepartmentsSliderCard400
                  article={props.departments.ArticlesFilteredsData400 || []}
                  cardSecTitle={props.cardSecTitle}
                  cardSecSubTitle={props.cardSecSubTitle}
                  cardSecContent={props.cardSecContent}
                  cardSecInfo={props.cardSecInfo}
                />
                <DepartmentsSliderCard404
                  article={props.departments.ArticlesFilteredsData404 || []}
                  cardSecTitle={props.cardSecTitle}
                  cardSecSubTitle={props.cardSecSubTitle}
                  cardSecContent={props.cardSecContent}
                  cardSecInfo={props.cardSecInfo}
                />
                <DepartmentsSliderCard393
                  article={props.departments.ArticlesFiltereds393Data || []}
                  cardSecTitle={props.cardSecTitle}
                  cardSecSubTitle={props.cardSecSubTitle}
                  cardSecContent={props.cardSecContent}
                  cardSecInfo={props.cardSecInfo}
                />                
              </Slider>
            </div>
          </div>
      </div>
    </div>
  );
};

export default DepartmentsSlider;
